import useWindowDimensions from './useWindowDimensions';
import { useLayoutEffect, useState } from 'react';
import { twConfig } from 'ui/ds/utils/getConfig';
import get from 'lodash.get';

const calcBreakpoints = (clientWidth: number | null) => {
  const screens = get(twConfig, 'theme.screens') as Record<string, string>;

  if (clientWidth == null) {
    return {
      isMobile: null,
      isTablet: null,
      isDesktop: null,
    };
  }

  return {
    isMobile: clientWidth <= Number(screens?.['sm']?.slice?.(0, -2) ?? 0),
    isTablet:
      clientWidth > Number(screens?.['sm']?.slice?.(0, -2) ?? 0) &&
      clientWidth <= Number(screens?.['md']?.slice?.(0, -2) ?? 0),
    isDesktop: clientWidth > Number(screens?.['md']?.slice?.(0, -2) ?? 0),
  };
};

const useBreakpoints = (): {
  isMobile: boolean | null;
  isTablet: boolean | null;
  isDesktop: boolean | null;
} => {
  const [[clientWidth]] = useWindowDimensions();

  const [breakpoints, setBreakpoints] = useState(() =>
    calcBreakpoints(clientWidth)
  );

  useLayoutEffect(() => {
    setBreakpoints(calcBreakpoints(clientWidth));
  }, [clientWidth]);

  return breakpoints;
};

export default useBreakpoints;
